const $jsCollapse = $('.js-collapse-scroll');

$jsCollapse.on('shown.bs.collapse', function () {
  const $this = $(this);

  const labelled = $this.attr('aria-labelledby');
  const $labelledId = $(`#${labelled}`);

  const offsetTop = $labelledId.offset().top;

  $('html, body').animate({
    scrollTop: offsetTop,
  }, 600, () => {
    window.scrollTo(0, offsetTop);
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/scroll-to-collapse/index.js